/* eslint-disable no-console */

import { register } from 'register-service-worker'

register(`${process.env.BASE_URL}service-worker.js`, {
  // registrationOptions: { scope: './' },
  ready (registration) {
    // console.log('App is being served from cache by a service worker.')
  },
  registered (registration) {
    // console.log('Service worker has been registered.')
    setInterval(() => {
      registration.update()
    }, 1000 * 60 * 60) // hourly
  },
  cached (registration) {
    // console.log('Content has been cached for offline use.')
  },
  updatefound (registration) {
    // console.log('New content is downloading.')
  },
  updated (registration) {
    // console.log('New content is available; refreshing.')

    document.dispatchEvent(
      new CustomEvent('swUpdated', { detail: registration })
    )
  },
  offline () {
    // console.log('No internet connection found. App is running in offline mode.')
  },
  error (error) {
    console.error('Error during service worker registration:', error)
  }
})
